function filterUnavailableCombinedOptions() {
  document.querySelectorAll('select').forEach(function(select) {
    select.querySelectorAll('option').forEach(function(option) {
      if (option.textContent.trim().endsWith('- Unavailable')) {
        option.disabled = true;
      } else {
        option.disabled = false;
      }
    });

    // If currently selected option is disabled, jump to first enabled one
    if (select.selectedOptions[0] && select.selectedOptions[0].disabled) {
      var firstEnabled = select.querySelector('option:not([disabled])');
      if (firstEnabled) {
        select.value = firstEnabled.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}

let debounceTimer;
const observer = new MutationObserver(function() {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(filterUnavailableCombinedOptions, 300);
});

filterUnavailableCombinedOptions();
observer.observe(document.body, { childList: true, subtree: true });